import { type ForwardRefRenderFunction, forwardRef, createRef } from "react";
import classNames from "classnames";
import NuButton from "@_nu/react-button";
import type { ButtonProps } from "./interfaces";
import { is } from "../_util/is";
import styles from "./style.module.scss";

const InternalButton: ForwardRefRenderFunction<HTMLElement, ButtonProps> = (
  {
    size,
    ghost,
    flat,
    block,
    primary,
    loading,
    disabled,
    className = "",
    classNameText = "",
    children = null,
    ...otherProps
  },
  ref
) => {
  const buttonRef = (ref as any) || createRef<HTMLElement>();

  // class
  const buttonClassName = classNames(className, styles.button, {
    _fill: !ghost && !flat,
    _ghost: ghost,
    _xxs: is(size, "xxs"),
    _xs: is(size, "xs"),
    _sm: is(size, "sm"),
    _md: is(size, "md"),
    _lg: is(size, "lg"),
    _block: block,
    _primary: primary,
    _loading: loading,
    _disabled: disabled,
  });

  return (
    <NuButton
      ref={buttonRef}
      disabled={!!disabled}
      className={buttonClassName}
      {...otherProps}
    >
      <span className={classNames(styles.text, classNameText, "db")}>
        {children}
      </span>
    </NuButton>
  );
};

const Button = forwardRef<HTMLElement, ButtonProps>(InternalButton);

export default Button;
